module.exports = __webpack_public_path__ + "img/scene.02780059.jpg";